var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2427_319857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2427_319857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24915 11.125V5.75C9.24915 5.54167 9.32207 5.36458 9.4679 5.21875C9.61373 5.07292 9.79082 5 9.99915 5C10.2075 5 10.3846 5.07292 10.5304 5.21875C10.6762 5.36458 10.7492 5.54167 10.7492 5.75V11.125L12.4158 9.45833C12.5686 9.30556 12.7457 9.22917 12.9471 9.22917C13.1485 9.22917 13.3255 9.30556 13.4783 9.45833C13.6311 9.61111 13.7075 9.78819 13.7075 9.98958C13.7075 10.191 13.6311 10.3681 13.4783 10.5208L10.52 13.4792C10.3672 13.6319 10.1936 13.7083 9.99915 13.7083C9.80471 13.7083 9.6311 13.6319 9.47832 13.4792L6.51998 10.5208C6.36721 10.3681 6.29429 10.191 6.30123 9.98958C6.30818 9.78819 6.38804 9.61111 6.54082 9.45833C6.6936 9.30556 6.87068 9.22917 7.07207 9.22917C7.27346 9.22917 7.45054 9.30556 7.60332 9.45833L9.24915 11.125Z",
    fill: "#B6C2D6"
  }))));
};
export default SvgDownArrow;